import { cn } from "@/lib/utils";

export const fieldInput = cn(
  "w-full rounded-sm border border-border bg-background px-4 py-3.5 text-base text-foreground outline-none transition-colors",
  "placeholder:text-muted-foreground/70 focus:border-primary focus:ring-1 focus:ring-primary",
);

export const fieldLabel = "eyebrow mb-2.5 block text-muted-foreground";

export const fieldError = "mt-2 text-sm text-destructive";

export const fieldHelp = "mt-2 text-sm leading-relaxed text-muted-foreground";
